export default __webpack_public_path__ + "static/media/ExampleA6.fdbaed6b.png";